<section class="card">
  <div class="card-header" *ngIf="!ismodal">
      <span class="cat__core__title">
          <strong>{{PageTitle}} <span *ngIf="sharerName">:- {{sharerName}}</span></strong>
      </span>
      <span style="float: right">
          <button type="button" class="btn btn-sm btn-default" (click)="back()">
              <i class="fa fa-chevron-circle-left"></i>&nbsp;Back</button>

      </span>

  </div>
  <div class="modal-header" *ngIf="ismodal">
      <h5 class="modal-title">Add Sharer</h5>
      <button aria-label="Close" class="close" type="button" (click)="activeModal.dismiss('close')">
        <i class="fa fa-times"></i>
      </button>
    </div>
  <div class="card-block">
      <div class="row">

          <div class="col-md-12">
              <form [formGroup]="addUPSISharer" class="well" NoValidate>

                  <div class="modal-body">
                      <div class="row">
                          <div class="col-lg-2">
                              <label class="form-control-label">Name</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['Name']"
                                      class="form-control" style="padding:6px;">
                                  <div *ngIf="addUPSISharer.controls['Name'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Name is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['Name'].hasError('required') && addUPSISharer.controls['Name'].touched"
                                      class="form-control-error-custom">
                                      Name is required.
                                  </div>
                                  <div *ngIf="!addUPSISharer.controls['Name'].hasError('required') && addUPSISharer.controls['Name'].hasError('whitespace') && addUPSISharer.controls['Name'].touched"
                                      class="form-control-error-custom">
                                      Name is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['Name'].hasError('maxlength')"
                                      class="form-control-error-custom">
                                      Name must be less than 50 characters.
                                  </div>
                                  <div *ngIf="addUPSISharer.get('Name')?.errors?.['inappropriateLanguage'] && addUPSISharer.get('Name')?.touched"
                                      class="form-control-error-custom">
                                      {{ addUPSISharer.get('Name')?.errors?.['inappropriateLanguage']?.message }}
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-2">
                              <label class="form-control-label">Sharer Code</label>

                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['EmpCode']"
                                      class="form-control" style="padding:6px;">
                                  <div *ngIf="addUPSISharer.controls['EmpCode'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Employee Code is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['EmpCode'].hasError('maxlength')"
                                      class="form-control-error-custom">
                                      Employee Code must be less than 25 characters.
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-2">
                              <label class="form-control-label">Designation</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['Designation']"
                                      class="form-control" style="padding:6px;">
                                  <div *ngIf="addUPSISharer.controls['Designation'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Designation is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['Designation'].hasError('maxlength')"
                                      class="form-control-error-custom">
                                      Designation must be less than 50 characters.
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-2">
                              <label class="form-control-label">Department</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['Department']"
                                      class="form-control" style="padding:6px;">
                                  <div *ngIf="addUPSISharer.controls['Department'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Department is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['Department'].hasError('maxlength')"
                                      class="form-control-error-custom">
                                      Department must be less than 50 characters.
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-2">
                              <label class="form-control-label">Unique Identifier</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <select class="form-control"
                                      [formControl]="addUPSISharer.controls['Unique_Identifier_Type']"
                                      style="padding:6px;" (change)="onChangeUIType()">
                                      <option value="" [selected]="true">select</option>
                                      <option value="PAN"> PAN</option>
                                      <option value="Other"> Other</option>
                                  </select>
                                  <div *ngIf="addUPSISharer.controls['Unique_Identifier_Type'].hasError('required') && addUPSISharer.controls['Unique_Identifier_Type'].touched"
                                      class="form-control-error-custom">
                                      Please select Unique Identifier.
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-2" *ngIf = "!DocumentFileDoc">
                              <label class="form-control-label">Upload Document</label>
                              <!-- <span _ngcontent-c2="" style="color: red;">*</span> -->
                          </div>
                          <div class="col-lg-4" *ngIf = "!DocumentFileDoc">
                              <div class="form-group">
                                  <label class="input-group">
                                      <input data-toggle="tooltip" type="text"
                                          [value]="listOfFiles.length > 0 ? listOfFiles.length  + ' Files Selected':' File Not Available'"
                                          class="form-control" [disabled]="true">

                                      <!-- <span *ngIf="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 && agenda.AgendaGenerationPdf[0].IsAvailable" (click)="downloadDoc(agenda.AgendaGenerationPdf[0].DocumentManagementID)"
                                                  class="input-group-addon default">
                                                  <i class="fa fa-download"></i>
                                              </span> -->
                                      <span class="input-group-addon warning"
                                          (click)="initiateUploadDocument($event)"
                                         >
                                          <i class="fa fa-upload"></i>
                                      </span>

                                  </label>
                                  <!-- <input type="file" class='form-control' (change)="fileChanged($event)"
                                  accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"> 
                                  <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span> -->
                              </div>
                          </div>

                          <div class="col-lg-2" *ngIf = "DocumentFileDoc">
                              <label class="form-control-label">Upload Document</label>
                          </div>
                          <div class="col-lg-4" *ngIf = "DocumentFileDoc"  > 
                              <label class="input-group">
                                  <input data-toggle="tooltip" type="text"
                                      [value]="(fileNameArray.length+listOfFiles.length) > 0 ? listOfFiles.length + fileNameArray.length  + ' Files Selected':' File Not Available'"
                                      class="form-control" [disabled]="true">

                                  <!-- <span *ngIf="agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length > 0 && agenda.AgendaGenerationPdf[0].IsAvailable" (click)="downloadDoc(agenda.AgendaGenerationPdf[0].DocumentManagementID)"
                                              class="input-group-addon default">
                                              <i class="fa fa-download"></i>
                                          </span> -->
                                  <span class="input-group-addon warning"
                                      (click)="initiateUploadDocument($event)"
                                     >
                                      <i class="fa fa-upload"></i>
                                  </span>

                              </label>
                            
                              <!-- <a class="btn btn-sm btn-default" *ngFor="let file of fileNameArray; let index = index">
                                  <span (click)="downloadFile()">{{file}}</span>&nbsp;
                                  <span (click)="downloadFile(index)" style="margin-left: 10px">
                                      <i class="fa fa-download"></i></span>
                                      <span (click)="deleteFile(index)" style="margin-left: 10px"><i class="fa fa-close" style="color: white"></i></span></a> -->
                              
                          </div>


                          <div class="col-lg-2" *ngIf="documentType == 'PAN'">
                              <label class="form-control-label">PAN</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4" *ngIf="documentType == 'PAN'">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['Document_No']"
                                      class="form-control" style="padding:6px;text-transform:uppercase;"
                                      (focusout)="DocumentValidation($event)"  (change)="DocumentValidation($event)"
                                      (keydown)="DocumentValidation($event)">

                                  <div *ngIf="checkOtherDocumentNoValD"  class="form-control-error-custom">
                                      PAN is invalid.
                                  </div>
                                  <div *ngIf="panNumberReq"
                                      class="form-control-error-custom">
                                      PAN is required.
                                  </div>
                              </div>
                          </div>


                          <div class="col-lg-2" *ngIf="documentType == 'Other'">
                              <label class="form-control-label">Other Document Name&nbsp;<span _ngcontent-c2="" style="color: red;">*</span></label>
                              
                          </div>
                          <div class="col-lg-4" *ngIf="documentType == 'Other'">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['other_document_name']"
                                      class="form-control" style="padding:6px;"
                                      (change)="otherDocumentNameFun($event)"
                                      (keydown)="otherDocumentNameFun($event)">
                                  <div *ngIf="otherDocumentName" class="form-control-error-custom">
                                      Other Document Name is required.
                                  </div>


                                  <div *ngIf="addUPSISharer.controls['other_document_name'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Other Document Name is not valid.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['other_document_name'].hasError('maxlength')"
                                      class="form-control-error-custom">
                                      Other Document Name must be less than 50 characters.
                                  </div>
                              </div>
                          </div>


                          <div class="col-lg-2" *ngIf="documentType == 'Other'">
                              <label class="form-control-label">Other Document No &nbsp;<span _ngcontent-c2="" style="color: red;">*</span></label>
                              
                          </div>
                          <div class="col-lg-4" *ngIf="documentType == 'Other'">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['Document_No']"
                                      class="form-control" style="padding:6px;" (focusout)="otherDocumentValidation($event)"  (change)="otherDocumentValidation($event)"
                                      (keydown)="otherDocumentValidation($event)">

                                  <div *ngIf="checkOtherDocumentNoVal"
                                      class="form-control-error-custom">
                                      Other  Document number is invalid.
                                  </div>
                                  <div *ngIf="otherNumberReq"
                                      class="form-control-error-custom">
                                      Other Document number is required.
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Email ID</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>

                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input type="text" [formControl]="addUPSISharer.controls['email_id']"
                                      class="form-control" style="padding:6px;"  (focusout)="checkuniqueEmail($event)">
                                  <div *ngIf="addUPSISharer.controls['email_id'].hasError('required') && addUPSISharer.controls['email_id'].touched"
                                      class="form-control-error-custom">
                                      Email id required.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['email_id'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Email ID is not valid.
                                  </div>
                                  <div *ngIf="checkUniqueEmail"  class="form-control-error-custom">

                                      This Email id is already exist.
                                  </div>


                              </div>
                          </div>

                          <div class="col-lg-2">
                              <label class="form-control-label">Mobile Number</label>
                              <span _ngcontent-c2="" style="color: red;">*</span>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input [formControl]="addUPSISharer.controls['ContactNumber']" class="form-control"
                                      pattern="^\d{10}$" (keydown)="onlyNumber($event)">
                                  <div *ngIf="addUPSISharer.controls['ContactNumber'].hasError('required') && addUPSISharer.controls['ContactNumber'].touched"
                                      class="form-control-error-custom">
                                      Mobile Number is required.
                                  </div>
                                  <div *ngIf="addUPSISharer.controls['ContactNumber'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Mobile Number is not valid.
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-2">
                              <label class="form-control-label">Tel Number</label>
                          </div>
                          <div class="col-lg-4">
                              <div class="form-group">
                                  <input [formControl]="addUPSISharer.controls['tele_Number']" class="form-control"
                                  pattern='^[a-zA-Z0-9!@#$*%_?<>|=&^()\\-`.+,:/\"]*'>
                                  <div *ngIf="addUPSISharer.controls['tele_Number'].hasError('pattern')"
                                      class="form-control-error-custom">
                                      Telephone Number is not valid.
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>


                  <div class="modal-footer" *ngIf="!ismodal">
                      <button id="btnSaveMeeting" type="button" *ngIf="!isEdit" class="btn btn-sm btn-primary"
                      [disabled]="!addUPSISharer.valid || disabledOnclick || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq || !fileExtension"
                          (click)="addAndUpdateSharer()">
                          <i class="fa fa-save"></i>&nbsp;Save</button>

                      <button id="btnSaveMeeting" *ngIf="isEdit" type="button" class="btn btn-sm btn-primary"
                          [disabled]="!addUPSISharer.valid || disabledOnclick || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq || !fileExtension"
                          (click)="addAndUpdateSharer()">
                          <i class="fa fa-save"></i>&nbsp;Update</button>

                      <button type="button" class="btn-sm btn btn-default" data-toggle="modal"
                          data-target="#clearDataModal">
                          <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                  </div>

                  <div class="modal-footer" *ngIf="ismodal">
                      <button id="btnSaveMeeting" type="button" *ngIf="!isEdit" class="btn btn-sm btn-primary"
                          [disabled]="!addUPSISharer.valid || disabledOnclick || otherDocumentName || checkUniqueEmail || checkOtherDocumentNoVal || checkOtherDocumentNoValD || panNumberReq || otherNumberReq"
                          (click)="addAndUpdateSharer()">
                          <i class="fa fa-save"></i>&nbsp;Save</button>
                          <button type="button" class="btn-sm btn btn-default" (click)="activeModal.dismiss('dismiss')">
                          <i class="fa fa-refresh"></i>&nbsp;Cancel</button>
                  </div>

                  <!-- <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby=""
                      aria-hidden="true" style="top: 50px;">
                      <div class="modal-dialog" role="document">
                          <div class="modal-content">
                              <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                                  Title!
                              </div>
                              <div class="modal-body">
                                  <div id="alertMessage">
                                      Message..
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>--->

                  <div class="modal fade" id="clearDataModal" tabindex="-1" role="dialog" data-backdrop="static"
                      data-keyboard="false" aria-labelledby="" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                          <div class="modal-content">
                              <div class="modal-header">
                                  <h5 class="modal-title" id="myModalLabelForDelete">
                                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                                      <i class="fa fa-times"></i>
                                  </button>
                              </div>
                              <div class="modal-body">
                                  <div class="row">
                                      <div class="col-sm-12">
                                          Are you sure you want to clear Sharer details?
                                      </div>
                                  </div>
                              </div>
                              <div class="modal-footer">
                                  <button type="button" class="btn btn-sm btn-danger" (click)="clear()"
                                      data-dismiss="modal">
                                      <i class="fa fa-check"></i>&nbsp;Yes</button>
                                  <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                                      <i class="fa fa-times"></i>&nbsp;No</button>
                              </div>
                          </div>
                      </div>
                  </div>
              </form>
          </div>
      </div>
  </div>
  <div class="modal fade modal-size-medium" id="upiSharerUploadDialog" tabindex="-1" role="dialog"
              data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title">
                              <i class="fa fa-upload"></i>
                              <span id="UpsiUploadTitle"></span>
                          </h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <i class="fa fa-times"></i>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="col-md-12">
                              <div class="row collapse1">
                                  <span class="cat__core__title">
                                      Existing Files
                                  </span>

                                  <table class="table table-hover compact cell-border nowrap stripe"
                                      style="cursor: pointer;">
                                      <thead>
                                          <tr>

                                              <th>Filename</th>
                                              <th>Action</th>
                                          </tr>
                                      </thead>
                                      <tbody *ngIf= "fileNameArray || listOfFiles">
                                          <tr *ngFor="let file of fileNameArray; let index = index">
                                              <td tabindex="1" style="cursor: move; width: 70%;">
                                                  {{file}}
                                              </td>
                                              <td>
                                                  <button type="button" class="btn-sm btn btn-warning"
                                                     (click)="downloadFile(file)">
                                                      <span class="fa fa-download"></span>
                                                  </button>
                                                  <button type="button" class="btn-sm btn btn-danger"
                                                  (click)="deleteFile(index)">
                                                      <span class="fa fa-close"></span>
                                                  </button>
                                              </td>
                                          </tr>
                                          <tr *ngFor="let selected of listOfFiles;let index = index">

                                              <td tabindex="1" style="cursor: move; width: 70%;">
                                                  {{selected}}
                                              </td>
                                              <td>
                                                  <button type="button" class="btn-sm btn btn-danger"
                                                      (click)="removeSelectedFile(index)">
                                                      <span class="fa fa-close"></span>
                                                  </button>
                                              </td>
                                          </tr>
                                          
                                      </tbody>
                                  </table>
                                  <div class="row">
                                      <div class="col-md-4">
                                          <label class="col-form-label" for="l5">
                                              <span>Document Attachment
                                                  <span _ngcontent-c2="" style="color: red;">*</span>
                                              </span>
                                          </label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              
                                              <input type="file" class='form-control fileUpload'
                                              #attachments type="file" (change)="onFileChanged($event)" #fileInput multiple="true"
                                                  accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4,.pptx"
                                                   />
                                              <!-- <span *ngIf="typeHasError" style="color: red">
                                                  Please upload valid file format.
                                              </span> -->

                                          </div>
                                          <!-- {{fileHasError | json}} -->
                                      </div>
                                  </div>

                              </div>
                          </div>
                      </div>
                      <div class="modal-footer">

                          <button id="saveAgendaDoc" type="button" class="btn-sm btn btn-primary"
                          
                               data-dismiss="modal">
                              <i class="fa fa-save"></i>&nbsp;Upload</button>

                          <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                              <i class="fa fa-times"></i>&nbsp;Close</button>

                      </div>
                  </div>
              </div>
  </div>

</section>
<app-alert></app-alert>